import { MemberSeatsSelectPage } from './MemberSeatsSelectPage';
export default MemberSeatsSelectPage;
